// crypto.getRandomValues()는 HTTPS 환경에서만 동작하므로 비보안 식별자 용도에 한해 Math.random() 사용
export function generateUUID(): string {
  // 템플릿의 4는 RFC 4122 version 필드 — "랜덤 기반 UUID"임을 나타내는 고정값
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, placeholder => {
    const randomInt = (Math.random() * 16) | 0;
    // y 자리는 RFC 4122 variant 필드 — 상위 2비트를 10으로 고정해야 하므로 결과가 8~b 범위로 제한됨
    return (placeholder === 'x' ? randomInt : (randomInt & 0x3) | 0x8).toString(16);
  });
}
